export default __webpack_public_path__ + "static/media/Brachiosaurio.512c0b87.png";